import type { UseFormReturn } from 'react-hook-form';
import { Labeled, TextInputField } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { ISendPushNotificationFormValues } from './SendPushNotificationForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';

export type ISendPushNotificationFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<ISendPushNotificationFormValues>;
};

export const SendPushNotificationFormMainSection: React.FC<
  ISendPushNotificationFormMainSectionProps
> = (props) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled
        label={t('SendPushNotificationFormMainSection.fields.title.label')}
        required
      >
        <FormField
          name="title"
          placeholder={t(
            'SendPushNotificationFormMainSection.fields.title.placeholder',
          )}
          control={form.control}
          as={TextInputField}
          forwardError
        />
      </Labeled>

      <Labeled
        label={t('SendPushNotificationFormMainSection.fields.content.label')}
        required
      >
        <FormField
          name="content"
          placeholder={t(
            'SendPushNotificationFormMainSection.fields.content.placeholder',
          )}
          control={form.control}
          as={TextInputField}
          forwardError
        />
      </Labeled>
    </FormSection>
  );
};
